import React from "react";
import { noop } from "lodash";
import styled from "styled-components";

export const RARadioGroup = ({ value, onChange = noop, options = [], ...props }) => {
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 16 }} {...props}>
			{options.map((option) => (
				<RadioWrapper key={option.value} onClick={() => onChange(option.value)}>
					<div>
						<RadioInput
							style={{
								borderColor: value === option.value ? "#ffb11a" : "#D6D6D6",
							}}
						>
							{value === option.value && <RadioDot />}
						</RadioInput>
					</div>
					{option.label}
				</RadioWrapper>
			))}
		</div>
	);
};

const RadioWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 400;
	line-height: 22px;
	color: #595959;
`;

const RadioInput = styled.div`
	width: 16px;
	height: 16px;
	border-width: 1px;
	border-style: solid;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
`;

const RadioDot = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: #ffb11a;
`;
